import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';

@Component({
	selector: 'app-callback',
  	template: `<p>Logging in...</p>`
})
export class LoginCallbackComponent {
		

	constructor(private oauthService: OAuthService, 		
		private router: Router) {		
	}
}
